export default __webpack_public_path__ + "static/media/Jahzzar_-_Zodiac.f5775662.mp3";